<template>
  <div>
    <SupplierCategoryRelationDialog
      ref="supplierCategoryRelationDialog"
      @update="list"
    />
    <SupplierCategoryPropertiesDialog
      ref="supplierCategoryPropertiesDialog"
      @update="list"
    />
    <v-data-table-server
      :headers="headers"
      :items="subCategories"
      :items-length="totalItems"
      :loading="loading"
      :items-per-page="100"
      item-value="name"
      class="elevation-1"
      @update:options="options = $event"
      fixed-header
    >
      <template v-slot:item.supplierCategoryName="{ item }">
        <td
          @click="createTab(item.props.title)"
          class="supplier-category-name font-weight-bold"
        >
          <span>{{ item.value.supplierCategoryName }} </span>
        </td>
      </template>
      <template v-slot:item.supplierGoodsStock="{ item }">
        <td>
          <span>
            <v-icon
              icon="$mdiCheck"
              v-if="item.value.isAnyGoodsInStock"
              color="success"
              v-bind="props"
            />
          </span>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <td>
          <v-tooltip :text="'Установить связь с подкатегорией'" location="top">
            <template v-slot:activator="{ props }">
              <span v-bind="props">
                <v-btn
                  :disabled="
                    category.backgroundJobState === 'Processing' ||
                    item.value.backgroundJobState === 'Processing'
                  "
                  flat
                  icon="$mdiRelationOneToOne"
                  @click="openRelationDialog(item.value)"
                ></v-btn>
              </span>
            </template>
          </v-tooltip>
          <v-tooltip
            v-if="supplier.id === mainSupplier.id"
            text="Загрузить свойства товаров подкатегории"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                :disabled="
                  category.backgroundJobState === 'Processing' ||
                  item.value.backgroundJobState === 'Processing'
                "
                v-bind="props"
                flat
                icon="$mdiListBoxOutline"
                @click="openSupplierCategoryPropertiesDialog(item.value)"
              >
              </v-btn>
            </template>
          </v-tooltip>
          <v-tooltip
            v-if="supplier.id !== mainSupplier.id"
            text="Связать товары и характеристики"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                :disabled="
                  (!item.value.categoryId && !item.value.isMainCategory) ||
                  category.backgroundJobState === 'Processing' ||
                  item.value.backgroundJobState === 'Processing'
                "
                v-bind="props"
                flat
                icon="$mdiListBoxOutline"
                @click="openSupplierCategoryPropertiesDialog(item.value)"
              >
              </v-btn>
            </template>
          </v-tooltip>
          <v-tooltip text="Получить товары подкатегории" location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                :disabled="
                  (!item.value.categoryId && !item.value.isMainCategory) ||
                  (item.value.backgroundJobState &&
                    item.value.backgroundJobState !== 'Succeeded' &&
                    item.value.backgroundJobState !== 'Failed')
                "
                flat
                icon="$mdiDownloadCircleOutline"
                @click="loadSupplierProducts(item.value)"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:item.loadDate="{ item }">
        <td>
          <span
            v-if="
              item.value.backgroundJobState !== 'Processing' &&
              !category.backgroundJobState !== 'Processing'
            "
          >
            {{ item.value.loadDate }}
          </span>
          <span
            v-if="
              category.backgroundJobState === 'Processing' ||
              item.value.backgroundJobState === 'Processing'
            "
            >Выполняется загрузка товаров...</span
          >
        </td>
      </template>
    </v-data-table-server>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SupplierCategoryRepository = RepositoryFactory.get("supplierCategory");
import SupplierCategoryRelationDialog from "@/components/Dialogs/SupplierCategoryRelationDialog/SupplierCategoryRelationDialog";
import SupplierCategoryPropertiesDialog from "@/components/Dialogs/SupplierCategoryPropertiesDialog/SupplierCategoryPropertiesDialog";
import { mapMutations, mapGetters } from "vuex";
const SupplierGoodsStockRepository =
  RepositoryFactory.get("supplierGoodsStock");
export default {
  props: ["category", "supplier"],
  components: {
    SupplierCategoryRelationDialog,
    SupplierCategoryPropertiesDialog,
  },
  data() {
    return {
      subCategories: [],
      loading: false,
      headers: [
        {
          title: "Категория поставщика",
          align: "start",
          sortable: false,
          key: "supplierCategoryName",
        },
        {
          title: "Категория каталога",
          align: "start",
          sortable: false,
          key: "relationCategoryName",
        },
        {
          title: "Дата последней загрузки товаров",
          align: "start",
          sortable: false,
          key: "loadDate",
        },
        {
          title: "Есть товары на складе",
          align: "start",
          sortable: false,
          key: "supplierGoodsStock",
        },
        {
          title: "Действия",
          align: "start",
          sortable: false,
          key: "actions",
        },
      ],
      options: {},
      totalItems: 0,
      categoryActiveTab: null,
      subcategoryTabs: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.list();
      },
      deep: true,
    },
    category: {
      handler() {
        if (this.category.backgroundJobState !== "Processing") {
          this.list();
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["setCategoryActiveTab"]),
    async list() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      const result =
        await SupplierCategoryRepository.getSubcategoriesBySupplierCategoryId(
          this.category.id,
          page,
          itemsPerPage
        );

      if (result && result.data.status === "success") {
        this.subCategories = result.data.data.rows;
        this.totalItems = result.data.data.totalCount;
        var categoryWithJobs = this.subCategories.filter(
          (x) => x.backgroundJobId > 0
        );
        for (let i = 0; i < categoryWithJobs.length; i++) {
          this.checkBackgorundJobStatus(categoryWithJobs[i]);
        }
      }
      this.loading = false;
    },
    openRelationDialog(item) {
      if (item.id) {
        this.$refs.supplierCategoryRelationDialog.openDialog(item);
      }
    },
    async openSupplierCategoryPropertiesDialog(item) {
      if (item.id) {
        if (this.supplier.id === this.mainSupplier.id) {
          this.loading = true;
          await SupplierCategoryRepository.saveCategoryProperties(
            [],
            this.supplier.id,
            item.id
          );
          this.loading = false;
        } else {
          this.$refs.supplierCategoryPropertiesDialog.openDialog(
            item.id,
            this.supplier.id
          );
        }
      }
    },
    async loadSupplierProducts(item) {
      let response = await SupplierGoodsStockRepository.loadSupplierProducts(
        item.id,
        item.supplierId
      );
      if (response && response.data.status === "success") {
        this.loading = true;
        this.checkBackgorundJobStatus(item);
      }
    },
    checkBackgorundJobStatus(item) {
      let timerId = setInterval(() => {
        SupplierGoodsStockRepository.checkLoadProductsStatus(item.id)
          .then((response) => {
            if (response && response.data.status === "success") {
              for (let i = 0; i < this.subCategories.length; i++) {
                if (this.subCategories[i].id === response.data.data.id) {
                  this.subCategories[i].loadDate = response.data.data.loadDate;
                  this.subCategories[i].isAnyGoodsInStock =
                    response.data.data.isAnyGoodsInStock;
                  this.subCategories[i].backgroundJobState =
                    response.data.data.backgroundJobState;
                }
              }
              if (response.data.data.backgroundJobState !== "Processing") {
                clearInterval(timerId);
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 2000);
    },
    createTab(item) {
      let oldDataTab = this.subcategoryTabs.find(
        (x) => x.id == `${item.id}_subcategory`
      );

      if (oldDataTab) {
        oldDataTab.name = item.supplierCategoryName;
        oldDataTab.item = item;
      } else {
        this.subcategoryTabs.push({
          id: item.id + "_subcategory",
          name: item.supplierCategoryName,
          item: item,
        });
      }
      this.setCategoryActiveTab(item.id + "_subcategory");
      this.$emit("updateSubcategories", this.subcategoryTabs);
    },
  },
  computed: {
    ...mapGetters(["mainSupplier"]),
  },
};
</script>
<style scoped>
.supplier-category-name {
  cursor: pointer;
}
</style>
